<template>
  <div class="dashboard">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-8 col-md-offset-2">
          <h1 class="page-header align-middle">Blockstack Todo App
            <img
              :src="user.avatarUrl() ? user.avatarUrl() : '/avatar-placeholder.png'"
              class="avatar"
            >
            <small><span class="sign-out">(<a
                  href="#"
                  @click.prevent="signOut"
                >Sign Out</a>)</span></small>
          </h1>
          <h2 class="user-info">
            <small>
              {{ user.name() ? user.name() : 'Nameless Person'}}'s Todos
            </small>
            <small class="float-right">
              {{ user.username ? user.username : user.identityAddress }}
            </small>

          </h2>
          <form
            @submit.prevent="addTodo"
            :disabled="! todo"
          >
            <div class="input-group">
              <input
                v-model="todo"
                type="text"
                class="form-control"
                placeholder="Write a todo..."
                autofocus
              >
              <span class="input-group-btn">
                <button
                  class="btn btn-default bg-light"
                  type="submit"
                  :disabled="! todo"
                >Add</button>
              </span>
            </div>
          </form>

          <ul class="list-group">
            <li
              v-for="todo in todos"
              class="list-group-item"
              :class="{completed: todo.completed}"
              :key="todo.id"
            >
              <label>
                <input
                  type="checkbox"
                  v-model="todo.completed"
                >{{ todo.text }}
              </label>
              <a
                @click.prevent="todos.splice(todos.indexOf(todo), 1)"
                class="delete float-right"
                href="#"
              >X</a>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userSession } from "../userSession";
var STORAGE_FILE = "todos.json";
export default {
  name: "dashboard",
  props: ["user"],
  data() {
    return {
      todos: [],
      todo: "",
      uidCount: 0
    };
  },
  watch: {
    todos: {
      handler: function(todos) {
        // encryption is now enabled by default
        return userSession.putFile(STORAGE_FILE, JSON.stringify(todos));
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    addTodo() {
      if (!this.todo.trim()) {
        return;
      }
      this.todos.unshift({
        id: this.uidCount++,
        text: this.todo.trim(),
        completed: false
      });
      this.todo = "";
    },
    fetchData() {
      userSession
        .getFile(STORAGE_FILE) // decryption is enabled by default
        .then(todosText => {
          var todos = JSON.parse(todosText || "[]");
          todos.forEach(function(todo, index) {
            todo.id = index;
          });
          this.uidCount = todos.length;
          this.todos = todos;
        });
    },
    signOut() {
      userSession.signUserOut(window.location.href);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dashboard {
  padding-top: 2rem;
}
input::placeholder {
  color: grey;
}
label {
  margin-bottom: 0;
  // width: 100%;
  cursor: pointer;
  input[type="checkbox"] {
    margin-right: 5px;
  }
}
.list-group-item {
  &.completed label {
    text-decoration: line-through;
  }
  .delete {
    display: none;
  }
  &:hover .delete {
    display: inline;
    color: grey;
    &:hover {
      text-decoration: none;
      color: red;
    }
  }
}
</style>